import { render } from "./modal-color-selection.vue?vue&type=template&id=fae8cb08&scoped=true"
import script from "./modal-color-selection.vue?vue&type=script&lang=js"
export * from "./modal-color-selection.vue?vue&type=script&lang=js"

import "./modal-color-selection.vue?vue&type=style&index=0&id=fae8cb08&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fae8cb08"],['__file',"src/components/login/modal-color-selection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fae8cb08"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fae8cb08', __exports__)) {
    api.reload('fae8cb08', __exports__)
  }
  
  module.hot.accept("./modal-color-selection.vue?vue&type=template&id=fae8cb08&scoped=true", () => {
    api.rerender('fae8cb08', render)
  })

}


export default __exports__